var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-row', { staticClass: "handler-bar", attrs: { "type": "flex", "justify": "space-between" } }, [_c('el-col', { staticStyle: { "display": "flex" }, attrs: { "span": _vm.layoutConfig[0] } }, [_vm._l(_vm.schema, function (itemSchema, index) {
    return [_c('el-schema-form', { key: index + '2', ref: "form", refInFor: true, attrs: { "schema": itemSchema, "model": _vm.model, "config": _vm.formConfig }, on: { "change": _vm.handleChange } })];
  })], 2), _vm._v(" "), _c('el-col', { attrs: { "span": _vm.layoutConfig[1] } }, [_c('div', { staticClass: "action-bar" }, [_vm._t("action-bar")], 2)])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };